import axios from "axios";
import config from "../config";

export const getAllTeams = () => axios.get(`${config.API_URL}/teams`)

export const getTeam = ({ teamSlug }: { teamSlug: string }) => axios.get(`${config.API_URL}/teams/${teamSlug}`)

export const getTeamContracts = ({ teamId, token }: { teamId: string, token: string }) => axios.get(`${config.API_URL}/teams/${teamId}/contracts`, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})

export const createTeam = ({
    name,
    slug,
    description,
    logo,
    token
}: {
    name: string;
    slug: string;
    description: string;
    logo: File | null;
    token: string;
}) => axios.postForm(`${config.API_URL}/teams`, {
    name,
    slug,
    description,
    logo
}, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})

export const joinTeam = ({ token, teamId }: { token: string, teamId: string }) => axios.postForm(`${config.API_URL}/teams/${teamId}/join`, {}, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})
export const leaveTeam = ({ token, teamId }: { token: string, teamId: string }) => axios.postForm(`${config.API_URL}/teams/${teamId}/leave`, {}, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})

export const searchTeamMember = ({
    token,
    teamId,
    name
}: {
    token: string,
    teamId: string,
    name: string
}) => axios.post(`${config.API_URL}/teams/${teamId}/search-member`, { name }, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})

export const createTeamContract = ({
    teamId,
    teamMemberId,
    value,
    startDate,
    endDate,
    conditions,
    token
}: {
    teamId: string;
    teamMemberId: string;
    value: number;
    startDate: string;
    endDate: string;
    conditions: string;
    token: string;
}) => axios.post(`${config.API_URL}/teams/${teamId}/contract`,
    {
        teamMemberId,
        value,
        startDate,
        endDate,
        conditions
    },
    {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }
)

export const updateTeamData = ({
    token,
    teamId,
    name,
    description
}: {
    token: string,
    teamId: string,
    name: string;
    description: string;
}) => axios.patch(`${config.API_URL}/teams/${teamId}`,
    {
        name,
        description
    },
    {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }
)

export const updateTeamLogo = ({
    token,
    teamId,
    logo,
}: {
    token: string,
    teamId: string,
    logo: File
}) => axios.patchForm(`${config.API_URL}/teams/${teamId}/logo`,
    {
        logo
    },
    {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }
)

export const searchTeam = ({ search }: { search: string }) => axios.post(`${config.API_URL}/teams/search`, { search })